import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

import InfoDrawer from '../common/_InfoDrawer.jsx';

export default class LDDFAQ extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.bricklinkAnnouncement = 'https://www.bricklink.com/v2/community/newsview.page?msgid=1166622';
		this.legoAnnouncement = 'https://www.bricklink.com/v2/community/newsview.page?msgid=1166621';

		this.state = {
				dummy: 0
			, openDrawers: []
			,	faqs: [
					{open: false, name: 'LEGO AMA', faqs: [
							{
								open: false
							,	question: "What’s the first thing I should do when I open Studio?"
							,	answer: `<p class="l-margin-bottom">Try out Studio’s tutorial, which comes up automatically the first time you open the program. You can always go back to the tutorial via the welcome screen by clicking the Tutorial text link below the buttons.</p>
							<div>
								<img src="//static2.bricklink.com/img/ldd/ldd-tutorial-guide.png" alt="Screenshot highlighting the tutorial link on welcome screen of Studio" style="max-width:377px"/>
							</div>`
							}
						,	{
								open: false
							,	question: "How do I migrate my models from LDD to Studio?"
							,	answer: `Open Studio. In the left-hand column of the welcome screen, click the Import button. Then select your LXF file. In Studio, you can import .LXF, .LDR, .MPD, and .DAT files. Importing one of these files will bring it into a submodel. You’ll need to manually release the submodel to edit its contents. To do this, in the Step list on the right-hand side select the submodel. At the bottom of the scree, click the blue “Release” text. You can see this in action <a href="https://www.youtube.com/watch?t=65&v=tYXK2tBtMO0&feature=youtu.be" target="_blank">in this tutorial video</a>.`
							}
						,	{
								open: false
							,	question: "What sorts of issues might one expect when importing LDD files into Studio?"
							,	answer: `<p class="l-margin-bottom">You might encounter missing parts, especially if they’re decorated (printed) parts. Some parts may be oriented incorrectly, or they could be out of place. This is because of differences in the origin and orientation between LDD and Studio parts. You may need to spend some time cleaning up your imported models.</p>
							<p class="l-margin-bottom">If you see parts that appear as transparent outlines, it is because they are colliding with other parts. This might be because of small alignment issues that you can adjust. You can also turn off collision detection by pressing the Collision button in the top toolbar.</p>
							<p class="l-margin-bottom">You might also get an “unavailable color” warning for some parts. This shows up in the Step List on the right-hand side as a yellow “!” next to the part name. To resolve this, use the Color Validator and <a href="https://forum.bricklink.com/#p20492">see this forum post</a>.</p>
							<p>To request missing parts in Studio, <a href="https://forum.bricklink.com/viewforum.php?f=6">create a forum post in the Parts subforum here</a>.</p>`
							}
						,	{
								open: false
							,	question: "Does Studio keep up to date with the latest parts?"
							,	answer: `Yes. LDD has not updated its parts palette in some time. Studio updates its brick palette monthly.`
							}
						,	{
								open: false
							,	question: "Will my copy of LDD stop working?"
							,	answer: `If you have LDD downloaded and installed on your computer, it will not stop working. There may be a future OS upgrade where it will no longer be compatible, which is outside our control.`
							}
						,	{
								open: false
							,	question: "LDD was a great program for younger builders. How will Studio, which began targeted at adults, create a similar experience suited for kids?"
							,	answer: `It is challenging to deliver a single experience that is equally rewarding for both adult fans and young children alike. Improving the experience for younger users is a key area of focus on the Studio product roadmap. We are putting a lot of thought into this, because we know that we must think this fully through so any changes do not degrade the experience and joy for all users.`
							}
						,	{
								open: false
							,	question: "Is the LEGO Group and BrickLink going to support the LXF and LXFML formats going forward?"
							,	answer: `We will continue to support import of LXF into Studio, so you will always be able to import and access models built in LXF.`
							}
						,	{
								open: false
							,	question: "Are there some tutorials I can watch to get used to Studio?"
							,	answer: `<p class="l-margin-bottom">Yes, there are some great tutorial videos on YouTube. Check out these from Boone Builds:</p><ul class="bullet-list">
							<li class="l-margin-bottom--sm"><a href="https://www.youtube.com/watch?v=BUxP1A4NLGE" target="_blank">BrickLink Studio Tutorial Introduction</a></li>
							<li class="l-margin-bottom--sm"><a href="https://www.youtube.com/watch?v=tYXK2tBtMO0" target="_blank">Importing LDD Models into BrickLink Studio Tutorial </a></li>
							<li class="l-margin-bottom--sm"><a href="https://www.youtube.com/watch?v=REDNc-P-4tU" target="_blank">Top 10 Tips & Tricks for BrickLink Studio </a></li>
							<li class=""><a href="https://www.youtube.com/watch?v=5RnBxLSYEdg" target="_blank">BrickLink Studio Instructions Maker Tutorial </a></li>
							</ul>`
							}
						,	{
								open: false
							,	question: "I can’t find a part in Studio. How do I find it?"
							,	answer: `In the search field of the parts palette, try searching for the dimensions of the part, for example 2 x 4. Scroll through the results to see if you can find your desired part. For additional tips on finding parts, please see the “I can’t find this part” FAQ in the <a href="https://forum.bricklink.com/viewtopic.php?f=6&t=6368&sid=05e1b7a31ff413e16c2a4ecc3ba1583e">Studio Parts Forum</a>. If your part doesn’t exist in Studio, the Studio community keeps track of parts that need to be added to official releases. See if you can find your desired part in the <a href="https://sites.google.com/view/parts-for-studio/" target="_blank">Parts for Studio</a> site.`
							}
						,	{
								open: false
							,	question: "I'm trying to connect two parts. They don't connect in Studio, even though they're compatible in real life. "
							,	answer: `You can either manually translate (move around) or rotate your part, or use the Connect tool. To manually translate and rotate, click the part to select it and use the blue icons to move it manually or change its orientation. To use the Connect tool, check out the <a href="https://www.youtube.com/watch?v=REDNc-P-4tU&t=444s" target="_blank">Snap and Connect section of Boone’s Top 10 Tips and Tricks video</a>. Note that all Studio parts have a connection info file (.conn file). These files have the part number as its file name and you can find them in your Studio folder under &#x5c;ldraw&#x5c;connectivity&#x5c;. If you discover a part that's missing its .conn file, you can add it using <a href="https://www.bricklink.com/v3/studio/partdesigner.page">Parts Designer</a> and submit fixed parts to the <a href="https://github.com/Cheenzo/StudioParts" target="_blank">Studio Parts Repository</a> on GitHub.`
							}
						,	{
								open: false
							,	question: "I don’t like the black interface. Can I change the background color of the viewport in Studio?"
							,	answer: `To change the background color, click Studio > Preferences (Mac) or Edit > Preferences (Windows), then select the Appearance tab. You can pick a new background color from this menu.`
							}
						,	{
								open: false
							,	question: "How do you set the center of your view in Studio?"
							,	answer: `right-click the area you want to view and select "Set as Origin." You can also use your center mouse button to pan the camera.`
							}
						,	{
								open: false
							,	question: "What's the Studio equivalent of LDD's Groups feature?"
							,	answer: `<p class="l-margin-bottom">Studio has a Submodel feature. There are multiple ways to create a submodel:</p>
							<ol class="number-list l-margin-bottom"><li class="l-margin-bottom--sm">Select multiple bricks by holding down CMD (Mac) or CTRL (Windows) and choosing your bricks. You can also click and drag across a field of bricks to mass-select. Unlike LDD, this selects every part in the box, not just parts on the surface. Right-click the selection and choose Submodel > Create. Name your submodel and click OK. </li>
							<li>Go to the step editor in the lower right corner. Select multiple parts by holding CTRL / CMD and clicking multiple parts. On the bottom right of the model viewer, select “Create Into Submodel.” Name your submodel and click OK.</li></ol>
							<p>Your new named submodel will appear in the step editor.</p>`
							}
						,	{
								open: false
							,	question: "How do you create building instruction steps?"
							,	answer: `To the left of the build window, you can see the Step List. Click the blue “+ Add Step” link, then drag parts and submodels into your step. Build mode, there is a step editor in the lower right hand corner. Click “Add Step” and drag parts and submodels between steps. You can also open Instruction Maker by clicking the “Instruction” button on the top menu bar. Note that while in Building Instructions mode, you can’t alter the model itself. To modify your model, return to Building Mode.`
							}
						,	{
								open: false
							,	question: "What's the Studio equivalent of LDD's Building Guide Mode?"
							,	answer: `Studio has Instruction Mode. On the main toolbar, click the second rightmost icon, Instruction. To exit from Instruction mode, click the exit icon in the upper left.`
							}
						,	{
								open: false
							,	question: "How do I handle flexible parts in Studio?"
							,	answer: `Studio handles flexible parts differently than LDD, and the Studio team knows there is room for improvement. You can check out a couple user tutorials on how Studio currently handles flexible parts, including this <a href="https://www.brickbanter.com/post/flexible-parts-bricklink-studio-tutorial" target="_blank">article from Brick Banter</a> and <a href="https://www.youtube.com/watch?t=636&v=REDNc-P-4tU&feature=youtu.be" target="_blank">this section of Boones' Top 10 Tips and Tricks video</a>.`
							}
						,	{
								open: false
							,	question: "Some parts I used in LDD are not available in Studio. Is it possible to import and use them?"
							,	answer: `If some of your LDD parts do not appear in Studio, either Studio is missing an official part or your LDD model used custom parts. You can create parts for Studio, add decals, or edit connectivity for parts using <a href="https://www.bricklink.com/v3/studio/partdesigner.page">Part Designer</a>. You can submit official parts to the <a href="https://github.com/Cheenzo/StudioParts" target="_blank">Studio Parts Repository</a> on GitHub.`
							}
						,	{
								open: false
							,	question: "Is there a place I can go to ask for help, request new features, or give bug reports to the Studio team?"
							,	answer: `Yes. Studio developers and users are active on the <a href="https://forum.bricklink.com/">BrickLink Studio Forum</a>.`
							}
						,	{
								open: false
							,	question: "Where can I learn more about the history of LDD?"
							,	answer: `Check out the <a href="https://podcasts.apple.com/us/podcast/unity/id1542166642?i=1000504501540" target="_blank">Unity episode of the Bits n’ Bricks podcast</a>. It traces the history of LDD and draws a line to the present LEGO Unity Microgame project. In late January, <a href="https://open.spotify.com/show/40EbVoUMdbKCkdaHKBt9UO?si=TedbXs1dQAGAK3S2O4u-0Q%3Ficmp%3DLP-SHQL-Standard-Digital_Gaming_Podcast_QL_Spotify-TH-NO-XEUXSWA1JQ&nd=1" target="_blank">Bits n’ Bricks</a> will feature a deep dive into LEGO Digital Designer, BrickLink Studio, and how the two evolved.`
							}
						// ,	{
						// 		open: false
						// 	,	question: ""
						// 	,	answer: ``
						// 	}
						]
					}
				]
		};
	}

	render() {
		return (
			<div className="main announc">
				<div className="main__content">
					<div className="edge-to-edge-container ldd-studio__header">
						<div className="edge-to-edge-container__internal">
							<section className="ldd-studio__header-main">
								<div className="ldd-studio__header-text">
									<h1 className="l-margin-bottom--md ldd-studio__header-title">Welcome LEGO&reg; Digital Designer Users</h1>
									<h2 className="ldd-studio__header-sub text--inherit">Easily transition to BrickLink Studio.</h2>
									<div className="ldd-studio__header-cta">
										<a href="#faqs" className="btn btn--outline-white text--bold ldd-studio__header-cta-item">Jump to FAQs<i className="fas fa-long-arrow-down l-margin-left--sm"/></a>
										<a href="//forum.bricklink.com/" target="_blank" className="btn btn--white text--bold ldd-studio__header-cta-item">Visit Studio Forum<i className="far fa-external-link-square-alt l-margin-left--sm"/></a>
									</div>
								</div>
								<div className="ldd-studio__header-image">
									<div className="ldd-studio__header-image-item">
										<img src={"//" + blapp.config.getHost( "static2" ) + "/img/ldd/studio-app.png"} alt="Laptop with Studio app on the screen" className="l-block"/>
									</div>
								</div>
							</section>
						</div>
					</div>

					{this.renderHeader()}

					<div id="faqs" className="ldd-studio__faqs">
						<div className="ldd-studio__faqs-header">
							<h2 className="ldd-studio__faqs-title">Frequently asked questions</h2>
							<button className="btn--link" onClick={() => this.openAllOfGroup(0)}>{this.state.faqs[0].open ? 'Collapse all' : 'Open all'}</button>
						</div>
						{this.renderFAQ()}
					</div>
				</div>
			</div>
		);
	}

	renderHeader() {
		const isMobile = (blapp.md.mobile() != null && blapp.md.isTouchSupported);

		return (
			<div className="ldd-studio__info">
				<div className="ldd-studio__info-logo">
					<img src={"//" + blapp.config.getHost("static2") + "/img/studio-logo-full-dark.png"} alt="Studio"/>
				</div>
				<h1 className="text--title text--bold l-margin-bottom--xl">With Studio, you can:</h1>
				<section className="ldd-studio__can">
					<article className="ldd-studio__can-item">
						<div className="ldd-studio__can-item-image">
							<img src={"//" + blapp.config.getHost("static2") + "/img/ldd/import.png"} alt="Import"/>
						</div>
						<p>Import your LDD models. </p>
					</article>
					<article className="ldd-studio__can-item">
						<div className="ldd-studio__can-item-image">
							<img src={"//" + blapp.config.getHost("static2") + "/img/ldd/export.png"} alt="Export"/>
						</div>
						<p>Import from and export to other popular 3D LEGO building formats. </p>
					</article>
					<article className="ldd-studio__can-item">
						<div className="ldd-studio__can-item-image">
							<img src={"//" + blapp.config.getHost("static2") + "/img/ldd/search.png"} alt="Search"/>
						</div>
						<p>Sign in with your BrickLink account. Look up parts, order your designs, and browse others’ designs for inspiration. </p>
					</article>
				</section>
				<div className="ldd-studio__info-footer">
					<strong>Build, render, and create instructions in Studio.</strong>
					<a className="btn ldd-studio__info-cta text--bold" href={blapp.url2.getStudioDownloadUrl()}>{isMobile ? "Learn more" : "Download today!"}</a>
				</div>
			</div>
		);
	}

	renderFAQ() {
		const faqsGroups = this.state.faqs.map((group, groupKey) => {
			const allOpen = group.open;

			const faqs = group.faqs.map((faq, key) => {
				return (
					<InfoDrawer key={key} icon={"arrow"} isOpen={faq.open} classes={"ldd-studio__faqs-item" + (this.state.faqs.length == 1 ? ' l-margin-bottom--sm' : '')} bold={true} label={faq.question}>
						<div className={"l-pad-top"} dangerouslySetInnerHTML={{__html: faq.answer}}/>
					</InfoDrawer>

					// <div key={key} className={"info-drawer info-drawer--left announc__faq-item" + (this.state.faqs.length == 1 ? ' l-margin-bottom--sm' : '')}>
					// 	<label className={"info-drawer__label"}>
					// 		<div className="l-full-width" dangerouslySetInnerHTML={{__html: `${key + 1}. ${faq.question}`}}/>
					// 		<input type="checkbox" className="info-drawer__checkbox" checked={faq.open} onChange={() => this.toggleItem(groupKey, key)}/><span className={"info-drawer__toggle info-drawer__toggle--square"}></span>
					// 	</label>
					// 	<div className={"info-drawer__content l-pad-bottom--sm" + (faq.open ? ' info-drawer__content--active' : '') + (this.state.faqs.length == 1 ? ' l-pad-left--null' : '')} dangerouslySetInnerHTML={{__html: faq.answer}}/>
					// </div>
				);
			});

			return (
				<section key={groupKey} id={group.name.replace(/ /g, '-')} className="announc__faq-group l-margin-bottom--xl">
					{this.state.faqs.length > 1 &&
						<div className="announc__faq-col announc__faq-col--left">
							<h3 className="announc__faq-group-title">{group.name}</h3>
						</div>
					}
					<div className={"announc__faq-col announc__faq-col--right" + (this.state.faqs.length == 1 ? ' l-pad-left--null' : '')}>
						{faqs}
						{this.state.faqs.length > 1 &&
							<button className="btn btn--link l-margin-top" onClick={() => this.openAllOfGroup(groupKey)}>{allOpen ? 'Hide' : 'Show'} all {group.name} answers</button>
						}
					</div>
				</section>
			);
		});
		
		return faqsGroups;
	}

	toggleItem(group, item) {
		const faqs = this.state.faqs;
					faqs[group].faqs[item].open = !faqs[group].faqs[item].open;

		const openItems = faqs[group].faqs.filter(item => item.open == true);
		
		if(openItems.length == faqs[group].faqs.length) {
			faqs[group].open = true;
		}else{
			faqs[group].open = false;
		}

		this.setState({faqs: faqs});
	}

	openAllOfGroup(group) {
		const faqs = this.state.faqs;
		const wasOpen = faqs[group].open;

		if(wasOpen) {
			faqs[group].open = false;

			faqs[group].faqs.map(item => item.open = false);
		}else{
			faqs[group].open = true;

			faqs[group].faqs.map(item => item.open = true);
		}

		this.setState({faqs: faqs});
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<LDDFAQ blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-main' )
						);
		blapp.refs.register( "main", elem );
	}
);
